<app-multi-select-dropdown
    *ngIf="filterInfo"
    [filterInfo]="filterInfo"
    [selectedValues]="selectedValues"
    (change)="selectionChange($event)"
>
</app-multi-select-dropdown>
